import xhr from '~/frontend/src/utilities/xhr';
import {
    CONFIG_LOAD,
    CONFIG_RELOAD,
    CONFIG_RECEIVE
} from '~/frontend/src/constants';
import {Dispatch} from 'redux';


export type LoadAction = {
    type : typeof CONFIG_LOAD;
};

/**
 * @memberOf! Actions
 *
 * @return {function}
 */
export const load = () => async ( dispatch : Dispatch ) : Promise<void> => {
    dispatch( {
        type: CONFIG_LOAD
    } );

    const result = await xhr.post(
        `${BASE_URL}/api/config/load`,
        undefined,
        undefined,
        'global_non_masking',
        'loadConfig',
        dispatch
    );

    if ( result?.data.data ) {
        global.config = result.data.data;
    }

    dispatch( receive( result?.data.data ) );
};


export type ReloadAction = {
    type : typeof CONFIG_RELOAD;
};

/**
 * @memberOf! Actions
 *
 * @return {Promise<void>}
 */
export const reload = () => async ( dispatch : Dispatch ) : Promise<void> => {
    dispatch( {
        type: CONFIG_RELOAD
    } );

    const result = await xhr.post(
        `${BASE_URL}/api/config/reload`,
        undefined,
        undefined,
        'global_non_masking',
        'reloadConfig',
        dispatch
    );

    if ( result?.data.data ) {
        global.config = result.data.data;
    }

    dispatch( receive( result?.data.data ) );
};


export type ReceiveAction = {
    type : typeof CONFIG_RECEIVE;
    data : any;
};

/**
 * @memberOf! Actions
 *
 * @param {any} data
 *
 * @return {ConfigReceiveAction}
 */
const receive = ( data : any ) : ReceiveAction => {
    return {
        type: CONFIG_RECEIVE,
        data
    };
};
